import $ from 'jquery';
import shave from 'shave';
import dom from './dom';

const related = () => {
  const relatedBottom = $('.c-related__bottom-grid');
  if (relatedBottom.length) {
    const children = relatedBottom.find('>.c-post__related-post');
    const childrenToRemove = relatedBottom.find('>p, h3');
    childrenToRemove.remove();
    children.each((i, el) => {
      const $self = $(el);
      if (i < 3) {
        $self.removeClass('c-post__related-post');
        $self.addClass(
          'o-grid__col o-grid__col-large--12 o-grid__col--4 c-archive__category-item c-related-posts__item',
        );
        $self.attr('data-trunc-post', '');
        $self
          .find('.rp4wp_component.rp4wp_component_taxonomy.rp4wp_component_3')
          .addClass('u-small-text c-archive__category-item-cat')
          .removeClass(
            'rp4wp_component rp4wp_component_taxonomy rp4wp_component_3',
          );
        $self.find('.rp4wp_component_excerpt p').attr('data-trunc', '');
      } else {
        $self.remove();
      }
    });
  }

  const updateTrunc = () => {
    if (dom.$win.width() >= 1000) {
      const truncWrapper = $('[data-trunc-post]');
      if (truncWrapper.length) {
        $.each(truncWrapper, (i, el) => {
          const $self = $(el);
          let title = $self.find(
            '.c-archive__category-link-content, .c-archive__love-list__item-title, .rp4wp_component_title',
          );
          if (title.length > 1) {
            title = $(title[1]);
          }
          const titleH = title.height();
          let shaveHeight = 115;
          if (titleH > 55) {
            shaveHeight = 100;
          }
          if (titleH > 85) {
            shaveHeight = 60;
          }
          if (titleH > 115) {
            shaveHeight = 30;
          }
          shave($self.find('[data-trunc]'), shaveHeight);
        });
      }
    }
  };
  updateTrunc();
  dom.$win.on('load', () => {
    updateTrunc();
  });
  dom.$doc.on('updateTrunc', () => {
    updateTrunc();
  });
};
export default related;



// WEBPACK FOOTER //
// ./src/scripts/modules/related.js